import { render } from "./TravelList.vue?vue&type=template&id=1cd30126"
import script from "./TravelList.vue?vue&type=script&lang=js"
export * from "./TravelList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__